// Caply Customer Identity — Entra External ID (CIAM) tenant
export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID || '21050c7b-5cf6-4b00-8969-db672791ece7';
export const MSAL_AUTHORITY = import.meta.env.VITE_MSAL_AUTHORITY || 'https://caplyid.ciamlogin.com/';

export const msalConfig = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: MSAL_AUTHORITY,
    knownAuthorities: ['caplyid.ciamlogin.com'],
    redirectUri: '/',  // resolves to current origin, matching the registered SPA redirect URIs
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes: the API accepts tokens with audience = the SPA client id,
// so requesting the client id as a scope yields exactly that.
export const loginRequest = {
  scopes: [`api://${MSAL_CLIENT_ID}/access_as_user`],
};
